// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1eR3f","content":"GlobalSearch_content__3c20A"};